import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;

//人才安居分页查询
export const GetApartmetnPage = (data) => {
  return axios.post(`${base}/api/Apartment/GetApartmetnPage`, data);
};

//删除人才安居
export const DeleteApartment = (params) => {
  return axios.delete(`${base}/api/Apartment/DeleteApartment`, {
    params: params,
  });
};

//添加公寓
export const AddApartment = (data) => {
  return axios.post(`${base}/api/Apartment/AddApartment`, data);
};

//查询人才公寓详情
export const GetApartmentById = (params) => {
  return axios.get(`${base}/api/Apartment/GetApartmentById`, {
    params,
  });
};

//修改人才公寓
export const PutApartment = (data) => {
  return axios.post(`${base}/api/Apartment/PutApartment`, data);
};

//查询申报人员
export const GetapartmentApprovlByPage = (data) => {
  return axios.post(
    `${base}/api/ApartmentApprovl/GetapartmentApprovlByPage`,
    data
  );
};
//删除申报人员
export const DeleteApprovle = (data) => {
  return axios.get(`${base}/api/ApartmentApprovl/DeleteApprovle`, {
    params: data,
  });
};
//查询申报人员详情
export const GetIntegraltalentDetails = (data) => {
  // return axios.get(`${base}/api/Approvl/GetIntegraltalentDetails`, { params: data });
  return axios.get(
    `${base}/api/ApartmentApprovl/GetApartmentApprovleTalentdetails`,
    {
      params: data,
    }
  );
};
//审核申报人员
export const PutApartmentApprovlState = (data) => {
  return axios.post(
    `${base}/api/ApartmentApprovl/PutApartmentApprovlState`,
    data
  );
};
